import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import VueIcon from "../components/icons/VueIcon.vue"
import CSharpIcon from "../components/icons/CSharpIcon.vue"
import LaravelIcon from "../components/icons/LaravelIcon.vue"
import KotlinIcon from "../components/icons/KotlinIcon.vue"
import AndroidIcon from "../components/icons/AndroidIcon.vue"
import GithubIcon from "../components/icons/GithubIcon.vue"
import LinkedInIcon from "../components/icons/LinkedInIcon.vue"
import ReactIcon from "../components/icons/ReactIcon.vue"
import RabbitMQIcon from "../components/icons/RabbitMQIcon.vue"
import KubernetesIcon from "../components/icons/KubernetesIcon.vue"
import AwsIcon from "../components/icons/AwsIcon.vue"
import AngularIcon from "../components/icons/AngularIcon.vue"
import TypescriptIcon from "../components/icons/TypescriptIcon.vue"
import GraphQLIcon from "../components/icons/GraphQLIcon.vue"

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#1976D2',
                primary_light: '#63A4FF',
                primary_dark: '#004BA0',
                secondary: '#F68718',
                secondary_light: '#FFA44B',
                secondary_dark: '#9B4800',

                main_background: '#195DA0',
                accent: '#8c9eff',
                error: '#b71c1c',

                source_code_button: "#2c2c2c"
            },
        },
    },
    icons: {
        values: {
            vueIcon: {
                component: VueIcon,
            },
            cSharpIcon: {
                component: CSharpIcon,
            },
            laravelIcon: {
                component: LaravelIcon,
            },
            kotlinIcon: {
                component: KotlinIcon,
            },
            androidIcon: {
                component: AndroidIcon,
            },
            githubIcon: {
                component: GithubIcon,
            },
            linkedInIcon: {
                component: LinkedInIcon,
            },
            reactIcon: {
                component: ReactIcon,
            },
            rabbitMqIcon: {
                component: RabbitMQIcon,
            },
            kubernetesIcon: {
                component: KubernetesIcon,
            },
            awsIcon: {
                component: AwsIcon,
            },
            graphQLIcon: {
                component: GraphQLIcon,
            },
            angularIcon: {
                component: AngularIcon,
            },
            typescriptIcon: {
                component: TypescriptIcon,
            }
        }
    },
})
